import merge from 'lodash.merge';

export default {
  changeLayers (state, layers) {
    state.enabledLayers = JSON.parse(JSON.stringify(layers))
  },
  changeCreateMode (state, value) {
    state.createMode = value
  },
  lockActivating (state, params) {
    let layer = {}
    if(params.type) {
      layer = {
        [params.groupId]: {
          [params.type]: true
        }
      }
    } else {
      layer = {
        [params.groupId]: true
      }
    }

    state.activatingLayer = merge({}, state.activatingLayer, layer)
  },
  unlockActivating (state, params) {
    if(params.type) {
      delete state.activatingLayer[params.groupId][params.type]
    } else {
      delete state.activatingLayer[params.groupId]
    }
    state.activatingLayer = {
      ...state.activatingLayer
    }
  },
  setLayersCache(state, mapLayersCache) {
    state.mapLayersCache = mapLayersCache
  },
  updateSelectedPeriod (state, payload) {
    state.selectedPeriod = {...payload}
  },
  updateZones(state, zone) {
    const index = state.zones ? state.zones.findIndex(v => v.id === zone.id) : -1
    if(index > -1) {
      state.zones[index] = zone
    } else {
      state.zones.push(zone)
    }
    state.zones = JSON.parse(JSON.stringify(state.zones))
  },
  setAdmTerritories(state, admTerritories) {
    state.admTerritories = admTerritories
  },
  addZonesToMap(state, zones) {
    state.zonesToAdd = zones
    const newMapZones = [].concat(state.mapZones)
    zones.forEach(zone => {
      const index = newMapZones.findIndex(v => v.id === zone.id)
      if(index > -1) {
        newMapZones[index] = zone
      } else {
        newMapZones.push(zone)
      }
    })
    state.mapZones = newMapZones
  },
  removeZonesFromMap(state, zones) {
    state.zonesToRemove = zones
    const ids = zones.map(v => v.id)
    state.mapZones = state.mapZones.filter(v => ids.indexOf(v.id) === -1)
  },
  newUserLayers (state, layers) {
    state.userLayers = layers;
  },
  zoneEditingModeOn (state, zone) {
    state.zoneEditing = zone
  },
  zoneEditingModeOff (state) {
    state.zoneEditing = null
  },
  getLayer (state, payload) {
    let [groupId, type, params] = payload
    let enabledLayers = state.enabledLayers
    if (type) {
      enabledLayers[groupId][type] = ['downloading', params]
    } else {
      enabledLayers[groupId] = ['downloading', params]
    }
    state.enabledLayers = JSON.parse(JSON.stringify(enabledLayers))
  },
  setNetworkGraph(state, payload) {
    state.networkGraph = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/workplace/mutations.js